// import React, { useContext, useEffect, useState, useMemo } from "react";
// import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
// import { ProfileContext } from "../../../context/ProfileProvider";
// import { Helmet } from "react-helmet-async";
// import "./profile-sidebar.css";

// // Helper to capitalize wallet name
// const capitalizeWallet = (str) => {
//   if (!str) return 'Wallet';
//   return str.charAt(0).toUpperCase() + str.slice(1) + ' Wallet';
// };

// const ProfilePage = (props) => {

//   const location = useLocation();
//   const { currentPage, setCurrentPage, walletTypes } = useContext(ProfileContext);

//   // Dynamic wallet page detection
//   useEffect(() => {
//     const path = location.pathname;

//     if (path.includes("/user_profile/dashboard")) setCurrentPage("Dashboard");
//     else if (path.includes("asset_overview")) setCurrentPage("Overview");
//     else if (path.includes("wallet/")) {
//       // Extract wallet type from path and set dynamic page name
//       const walletMatch = path.match(/wallet\/([^/]+)/);
//       if (walletMatch && walletMatch[1]) {
//         setCurrentPage(capitalizeWallet(walletMatch[1]));
//       }
//     }
//     else if (path.includes("spot_orders")) setCurrentPage("Spot Order");
//     else if (path.includes("transaction_history")) setCurrentPage("Transaction History");
//     else if (path.includes("open_orders")) setCurrentPage("Open Order");
//     else if (path.includes("swap_history")) setCurrentPage("Swap History");
//     else if (path.includes("profile_setting")) setCurrentPage("Settings");
//     else if (path.includes("kyc")) setCurrentPage("Verification");
//     else if (path.includes("bank")) setCurrentPage("Bank Details");
//     else if (path.includes("currency_preference")) setCurrentPage("Currency Preference");
//     else if (path.includes("support")) setCurrentPage("Support");
//     else if (path.includes("two_factor_autentication")) setCurrentPage("Security");
//     else if (path.includes("password_security")) setCurrentPage("Reset Password");
//     else if (path.includes("arbitrage_bot") || path.includes("arbitrage_dashboard")) setCurrentPage("Arbitrage Bot");
//     else if (path.includes("wallet_transfer_History")) setCurrentPage("Wallet Transfer History");
//     else if (path.includes("swap")) setCurrentPage("Quick Swap");
//     else if (path.includes("notification")) setCurrentPage("Notification");
//     else if (path.includes("activity_logs")) setCurrentPage("Activity logs");
//     else if (path.includes("earning_plan_history")) setCurrentPage("Earning Plan History");
//     else if (path.includes("bonus_history")) setCurrentPage("Bonus History");
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [location.pathname]);

//   // Check if current page is a wallet page
//   const isWalletPage = useMemo(() => {
//     return currentPage?.includes('Wallet') && currentPage !== 'Wallet Transfer History';
//   }, [currentPage]);

//   const [isActive, setIsActive] = useState(false);

//   const navigate = useNavigate();

//   const toggleContent = (page) => {
//     setIsActive(!isActive);
//     if (page) {

//       setCurrentPage(page)
//     }
//   };

//   const [openSection, setOpenSection] = useState(null);
//   const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

//   const toggleSection = (section) => {
//     setOpenSection(openSection === section ? null : section);
//   };

//   // Icon mapping for current page
//   const getPageIcon = useMemo(() => {
//     const iconMap = {
//       "Dashboard": "/images/dasboard_home.svg",
//       "Overview": "/images/dashboard_assets.svg",
//       "Spot Order": "/images/dashboard_order.svg",
//       "Open Order": "/images/dashboard_order.svg",
//       "Transaction History": "/images/dashboard_order.svg",
//       "Swap History": "/images/dashboard_order.svg",
//       "Wallet Transfer History": "/images/dashboard_order.svg",
//       "Earning Plan History": "/images/dashboard_order.svg",
//       "Bonus History": "/images/dashboard_order.svg",
//       "Settings": "/images/dashboard_profile.svg",
//       "Verification": "/images/dashboard_profile.svg",
//       "kyc": "/images/dashboard_profile.svg",
//       "Bank Details": "/images/dashboard_profile.svg",
//       "Currency Preference": "/images/dashboard_profile.svg",
//       "Support": "/images/dashboard_profile.svg",
//       "Earning": "/images/earning_icon3.svg",
//       "Security": "/images/dashboard_security.svg",
//       "Reset Password": "/images/dashboard_security.svg",
//       "Quick Swap": "/images/quick-swap.svg",
//       "Notification": "/images/dashboard_notification.svg",
//       "Activity logs": "/images/dashboard_logs.svg",
//     };

//     // Check if it's a wallet page
//     if (currentPage?.includes('Wallet') && currentPage !== 'Wallet Transfer History') {
//       return "/images/dashboard_assets.svg";
//     }

//     return iconMap[currentPage] || "/images/dasboard_home.svg";
//   }, [currentPage]);

//   const logOut = () => {
//     localStorage.clear();
//     navigate("/");
//     window.location.reload()
//   }

//   return (
//     <>
//       <Helmet>
//         <title> AGCX | The world class new generation crypto asset exchange</title>
//       </Helmet>
//       <div className="mobile_view" id="toggleBtn" onClick={() => toggleContent()}>
//         <img src={getPageIcon} alt={currentPage} width={20} height={20} style={{ marginRight: '8px' }} />
//         <div className="d-flex align-items-center justify-content-between w-100">
//         {currentPage}
//         <span><i className="ri-arrow-down-s-line"></i></span>
//         </div>
//       </div>


//       <div className="dashboard">


//         <div
//           id="content"
//           className={`${isActive ? "active flex-shrink-0 leftside_menu" : "flex-shrink-0 leftside_menu"} profile-sidebar-shell${sidebarCollapsed ? " profile-sidebar-shell--collapsed" : ""}`}
//         >
//           <button
//             type="button"
//             className="profile-sidebar-collapse-btn"
//             onClick={() => setSidebarCollapsed((c) => !c)}
//             aria-expanded={!sidebarCollapsed}
//             aria-label={sidebarCollapsed ? "Expand navigation" : "Collapse navigation"}
//           >
//             <i className={sidebarCollapsed ? "ri-arrow-right-s-line" : "ri-arrow-left-s-line"} aria-hidden="true" />
//           </button>

//           <ul className="list-unstyled ps-0 navi_sidebar">
//             <li onClick={() => toggleContent("Dashboard")} className={`${currentPage === "Dashboard" && "active"} mb-1`}>
//               <Link to="dashboard">
//               <img src="/images/dashboard_menu_icon.svg" alt="Overview" width={20} height={20} />
//                 <div className="dashboard_menu_hd"> Overview</div>
//               </Link>
//             </li>


//             <li onClick={() => toggleContent("Earning")} className={`${currentPage === "Earning" && "active"} mb-1`}>
//               <Link to="/earning">
//               <img src="/images/dashboard_menu_icon2.svg" alt="Security" width={20} height={20} />
//                 <div className="dashboard_menu_hd">
//                 Security
//                   {/* <p>Monitor earnings from staking, referrals, and trading activities.</p> */}
//                 </div>
//               </Link>
//             </li>


//             <li onClick={() => toggleContent("Security")} className={`${currentPage === "Security" && "active"} mb-1`}>
//               <Link to="two_factor_autentication">
//               <img src="/images/dashboard_menu_icon3.svg" alt="Identification" width={20} height={20} />
//                 <div className="dashboard_menu_hd">
//                 Identification
//                 </div>

//               </Link>
//             </li>

//             <li onClick={() => toggleContent("Quick Swap")} className={`${currentPage === "Quick Swap" && "active"} mb-1`}>
//               <Link to="swap">
//               <img src="/images/dashboard_menu_icon4.svg" alt="Subaccounts" width={20} height={20} />
//                 <div className="dashboard_menu_hd">
//                 Subaccounts
//                 </div>

//               </Link>
//             </li>

//             <li onClick={() => toggleContent("Notification")} className={`${currentPage === "Notification" && "active"} mb-1`}>
//               <Link to="notification">
//               <img src="/images/dashboard_menu_icon5.svg" alt="API Key" width={20} height={20} />
//                 <div className="dashboard_menu_hd">
//                 API Key Management
//                 </div>
//               </Link>
//             </li>

//             <li onClick={() => toggleContent("Activity logs")} className={`${currentPage === "Activity logs" && "active"} mb-1`}>
//               <Link to="activity_logs">
//               <img src="/images/dashboard_menu_icon6.svg" alt="Vouchers" width={20} height={20} />
//                 <div className="dashboard_menu_hd">
//                 Vouchers
//                 </div>
//               </Link>
//             </li>

//             <li onClick={() => toggleContent("Activity logs")} className={`${currentPage === "Activity logs" && "active"} mb-1`}>
//               <Link to="activity_logs">
//               <img src="/images/dashboard_menu_icon7.svg" alt="Tickets" width={20} height={20} />
//                 <div className="dashboard_menu_hd">
//                 My Tickets
//                 </div>
//               </Link>
//             </li>

//             <li onClick={() => toggleContent("Activity logs")} className={`${currentPage === "Activity logs" && "active"} mb-1`}>
//               <Link to="activity_logs">
//               <img src="/images/dashboard_menu_icon8.svg" alt="Settings" width={20} height={20} />
//                 <div className="dashboard_menu_hd">
//                 Settings
//                 </div>
//               </Link>
//             </li>

//           </ul>
//           <div className="logout_btn" onClick={logOut}>
//             <Link to="#/">Logout<i className="ri-logout-circle-r-line"></i></Link>
//           </div>
//         </div>
//         <Outlet />
//       </div>
//     </>
//   )
// }

// export default ProfilePage





import React, { useContext, useEffect, useState, useMemo } from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import { ProfileContext } from "../../../context/ProfileProvider";
import { Helmet } from "react-helmet-async";
import "./profile-sidebar.css";
import OrderSidebar from "../../../customComponents/OrderSidebar";
import DashboardSidebar from "../../../customComponents/DashboardSidebar";
import { isOrderSidebarPath } from "../../../customComponents/userProfileSidebarMode";
import WalletSidebar from "../../../customComponents/WalletSidebar";
import { logoutCurrentSession } from "../../../utils/sessionLogout";

// Helper to capitalize wallet name
const capitalizeWallet = (str) => {
  if (!str) return 'Wallet';
  return str.charAt(0).toUpperCase() + str.slice(1) + ' Wallet';
};

const getWalletPageName = (type) => {
  const mapping = {
    spot: "Spot Wallet",
    main: "Main Wallet",
    margin: "Isolated Margin Wallet",
    cross_margin: "Cross Margin Wallet",
    futures: "Futures Wallet",
    options: "Options Wallet",
    staking: "Staking Wallet",
    earning: "Earning Wallet",
  };
  return mapping[type] || (type.charAt(0).toUpperCase() + type.slice(1) + " Wallet");
};

const ProfilePage = (props) => {

  const location = useLocation();
  const { currentPage, setCurrentPage, walletTypes } = useContext(ProfileContext);

  const orderRail = useMemo(
    () => isOrderSidebarPath(location.pathname),
    [location.pathname]
  );

  const walletRail = useMemo(() => {
    const p = location.pathname;
    return p.includes("/user_profile/asset_overview")
      || p.includes("/user_profile/wallet/")
      || p.includes("/user_profile/cross_margin")
      || p.includes("/user_profile/staking");
  }, [location.pathname]);

  // Dynamic wallet page detection
  useEffect(() => {
    const path = location.pathname;

    if (path.includes("/user_profile/dashboard")) setCurrentPage("Overview");
    else if (path.includes("asset_overview")) setCurrentPage("Overview");
    else if (path.includes("/user_profile/staking")) setCurrentPage("Staking Wallet");
    else if (path.includes("cross_margin")) setCurrentPage("Cross Margin Wallet");
    else if (path.includes("wallet/")) {
      // Extract wallet type from path and set dynamic page name
      const walletMatch = path.match(/wallet\/([^/]+)/);
      if (walletMatch && walletMatch[1]) {
        setCurrentPage(getWalletPageName(walletMatch[1]));
      }
    }
    // Orders (keep mobile menu label stable across in-page subtabs)
    else if (
      path.includes("spot_orders") ||
      path.includes("spot_open_orders") ||
      path.includes("spot_order_history") ||
      path.includes("spot_position_history")
    ) {
      setCurrentPage("Spot Order");
    }
    else if (
      path.includes("futures_open_orders") ||
      path.includes("futures_order_history") ||
      path.includes("futures_trade_history") ||
      path.includes("position_history") ||
      path.includes("position_orders")
    ) {
      setCurrentPage("Futures Open Order");
    }
    else if (
      path.includes("options_open_orders") ||
      path.includes("options_order_history") ||
      path.includes("options_trade_history") ||
      path.includes("options_position_history")
    ) {
      setCurrentPage("Options Open Orders");
    }
    else if (
      path.includes("margin_orders") ||
      path.includes("margin_order_history") ||
      path.includes("margin_position_history") ||
      path.includes("margin_trade_history") ||
      path.includes("margin_transfer_history") ||
      path.includes("margin_borrowing_history")
    ) {
      setCurrentPage("Margin Orders");
    }
    else if (path.includes("deposit_history")) {
      setCurrentPage("Deposit History");
    }
    else if (path.includes("withdraw_history")) {
      setCurrentPage("Withdraw History");
    }
    else if (path.includes("/user_profile/orders/transfer")) {
      setCurrentPage("Transfer");
    }
    else if (path.includes("referral")) {
      setCurrentPage("Referral");
    }
    else if (
      path.includes("transaction_history") ||
      path.includes("swap_history") ||
      path.includes("wallet_transfer_History") ||
      path.includes("earning_plan_history") ||
      path.includes("bonus_history") ||
      path.includes("quick_buy_sell")
    ) {
      setCurrentPage("Asset History");
    }
    else if (path.includes("launchpad_orders")) setCurrentPage("Earning");
    else if (path.includes("staking_orders")) setCurrentPage("Earning");
    else if (path.includes("otc_trade") || path.includes("otc_orders") || path.includes("otc_order_history")) setCurrentPage("OTC");
    else if (path.includes("convert_orders")) setCurrentPage("Convert");
    else if (path.includes("copy_trading_orders")) setCurrentPage("Copy Trading");
    else if (path.includes("launchpad_transactions")) setCurrentPage("Launchpad Transactions");
    else if (path === "/user_profile/orders" || path.includes("/user_profile/orders/open_orders")) setCurrentPage("Open Order");
    else if (path.includes("notification_settings")) setCurrentPage("Notification Settings");
    else if (path.includes("profile_setting")) setCurrentPage("Settings");
    else if (path.includes("kyb")) setCurrentPage("Business Verification");
    else if (path.includes("kyc")) setCurrentPage("Identification");
    else if (path.includes("my_tickets")) setCurrentPage("My Tickets");
    else if (path.includes("bank")) setCurrentPage("Bank Details");
    else if (path.includes("currency_preference")) setCurrentPage("Currency Preference");
    else if (path.includes("support")) setCurrentPage("Support");
    else if (
      path.includes("two_factor_autentication") ||
      (path.startsWith("/user_profile/security") && !path.includes("/user_profile/security/"))
    ) {
      setCurrentPage("Security");
    }
    else if (path.includes("password_security")) setCurrentPage("Reset Password");
    else if (path.includes("arbitrage_bot") || path.includes("arbitrage_dashboard")) setCurrentPage("Arbitrage Bot");
    else if (path.includes("swap")) setCurrentPage("Quick Swap");
    else if (path.includes("notification")) setCurrentPage("Notification");
    else if (path.includes("activity_logs")) setCurrentPage("Activity logs");
    else if (path.includes("create_tickets")) setCurrentPage("Create Tickets");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const [isActive, setIsActive] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isActive) {
      const scrollY = window.scrollY;
      document.documentElement.classList.add("profile-sidebar--open");
      document.body.classList.add("profile-sidebar--open");
      document.body.style.top = `-${scrollY}px`;

      return () => {
        document.documentElement.classList.remove("profile-sidebar--open");
        document.body.classList.remove("profile-sidebar--open");
        const top = document.body.style.top;
        document.body.style.top = "";
        if (top) {
          window.scrollTo(0, parseInt(top || "0", 10) * -1);
        }
      };
    } else {
      document.documentElement.classList.remove("profile-sidebar--open");
      document.body.classList.remove("profile-sidebar--open");
      document.body.style.top = "";
    }
  }, [isActive]);

  /** Any in-app navigation: start with rail closed on mobile (avoids “stuck open” after desktop clicks). */
  useEffect(() => {
    setIsActive(false);
  }, [location.pathname]);

  /** Resize to mobile / narrow: collapse overlay so devtools device mode does not inherit open state. */
  useEffect(() => {
    const mq = window.matchMedia("(max-width: 991.98px)");
    const onChange = () => {
      if (mq.matches) setIsActive(false);
    };
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  /**
   * Mobile header bar: no arg → toggle open/close.
   * Sidebar item: pass label → update page title and always close (do not toggle: desktop was leaving `active` true).
   */
  const toggleContent = (page) => {
    if (page !== undefined && page !== null) {
      setCurrentPage(page);
      setIsActive(false);
    } else {
      setIsActive((v) => !v);
    }
  };

  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);

  // Icon mapping for current page (match DashboardSidebar icons)
  const pageIcon = useMemo(() => {
    /** @type {Record<string, {kind: "img"; src: string} | {kind: "ri"; className: string}>} */
    const iconMap = {
      Dashboard: { kind: "img", src: "/images/dasboard_home.svg" },
      Overview: { kind: "img", src: "/images/dashboard_menu_icon.svg" },
      // Orders rail (match OrderSidebar icons; subpages use parent icon)
      "Spot Order": { kind: "img", src: "/images/ordersidebar_menu_icon.svg" },
      "Spot Order History": { kind: "img", src: "/images/ordersidebar_menu_icon.svg" },
      "Spot Position History": { kind: "img", src: "/images/ordersidebar_menu_icon.svg" },
      "Open Order": { kind: "img", src: "/images/ordersidebar_menu_icon.svg" },

      "Futures Open Order": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },
      "Futures Order History": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },
      "Position History": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },
      "Position Orders": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },
      "Futures Trade History": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },
      "Options Open Orders": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },
      "Options Order History": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },
      "Options Trade History": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },
      "Options Position History": { kind: "img", src: "/images/ordersidebar_menu_icon2.svg" },

      "Margin Orders": { kind: "img", src: "/images/ordersidebar_menu_icon3.svg" },
      "OTC": { kind: "img", src: "/images/ordersidebar_menu_icon4.svg" },
      "Convert": { kind: "img", src: "/images/ordersidebar_menu_icon4.svg" },
      "Launchpad Transactions": { kind: "img", src: "/images/ordersidebar_menu_icon5.svg" },
      "Staking Orders": { kind: "img", src: "/images/ordersidebar_menu_icon6.svg" },
      Staking: { kind: "img", src: "/images/ordersidebar_menu_icon6.svg" },
      "Copy Trading": { kind: "img", src: "/images/ordersidebar_menu_icon7.svg" },
      "Fiat Asset Order": { kind: "img", src: "/images/ordersidebar_menu_icon10.svg" },
      "Quick Buy/Sell": { kind: "img", src: "/images/ordersidebar_menu_icon12.svg" },
      Identification: { kind: "img", src: "/images/dashboard_menu_icon3.svg" },
      "Business Verification": { kind: "img", src: "/images/kyb_menu_icon.svg" },
      "Transaction History": { kind: "img", src: "/images/ordersidebar_menu_icon11.svg" },
      "Deposit History": { kind: "img", src: "/images/ordersidebar_menu_icon7.svg" },
      "Withdraw History": { kind: "img", src: "/images/ordersidebar_menu_icon8.svg" },
      Transfer: { kind: "img", src: "/images/ordersidebar_menu_icon9.svg" },
      Referral: { kind: "img", src: "/images/ordersidebar_menu_icon10.svg" },
      "Swap History": { kind: "img", src: "/images/ordersidebar_menu_icon11.svg" },
      "Wallet Transfer History": { kind: "img", src: "/images/ordersidebar_menu_icon11.svg" },
      "Asset History": { kind: "img", src: "/images/ordersidebar_menu_icon11.svg" },
      "Earning Plan History": "/images/dashboard_order.svg",
      "Bonus History": "/images/dashboard_order.svg",
      Settings: { kind: "img", src: "/images/security/setting2.svg" },
      "Notification Settings": "/images/dashboard_notification.svg",
      "Verification": "/images/dashboard_profile.svg",
      "kyc": "/images/dashboard_profile.svg",
      "Bank Details": "/images/dashboard_profile.svg",
      "Currency Preference": "/images/dashboard_profile.svg",
      "Support": "/images/dashboard_profile.svg",
      "My Tickets": { kind: "img", src: "/images/security/tickets_icon.svg" },
      "Earning": { kind: "img", src: "/images/ordersidebar_menu_icon6.svg" },
      Security: { kind: "img", src: "/images/dashboard_menu_icon2.svg" },
      "Reset Password": "/images/dashboard_security.svg",
      "Quick Swap": "/images/quick-swap.svg",
      Notification: { kind: "ri", className: "ri-notification-3-line" },
      "Activity logs": { kind: "ri", className: "ri-history-line" },
      "Create Tickets": "/images/security/tickets_icon.svg",
    };

    // Wallet rail: match WalletSidebar icons
    if (walletRail) {
      if (currentPage === "Overview") return { kind: "ri", className: "ri-home-4-line" };
      if (currentPage === "Spot Wallet") return { kind: "ri", className: "ri-wallet-3-line" };
      if (currentPage === "Main Wallet") return { kind: "ri", className: "ri-safe-2-line" };
      if (currentPage === "Isolated Margin Wallet") return { kind: "ri", className: "ri-funds-line" };
      if (currentPage === "Cross Margin Wallet") return { kind: "ri", className: "ri-swap-box-line" };
      if (currentPage === "Futures Wallet") return { kind: "ri", className: "ri-line-chart-line" };
      if (currentPage === "Options Wallet") return { kind: "ri", className: "ri-stock-line" };
      if (currentPage === "Staking Wallet") return { kind: "ri", className: "ri-coins-line" };
      if (currentPage === "Earning Wallet") return { kind: "ri", className: "ri-hand-coin-line" };
    }

    if (currentPage?.includes("Wallet") && currentPage !== "Wallet Transfer History") {
      return { kind: "img", src: "/images/dashboard_assets.svg" };
    }

    const raw = iconMap[currentPage] || { kind: "img", src: "/images/dasboard_home.svg" };
    if (typeof raw === "string") return { kind: "img", src: raw };
    return raw;
  }, [currentPage]);

  const logOut = () => {
    void (async () => {
      await logoutCurrentSession();
      navigate("/", { replace: true, state: null });
    })();
  };

  return (
    <>
      <Helmet>
        <title> AGCX Exchange | The world class new generation crypto asset exchange</title>
      </Helmet>
      <div
        className={`mobile_view${isActive ? " mobile_view--open" : ""}`}
        id="toggleBtn"
        role="button"
        tabIndex={0}
        aria-expanded={isActive}
        onClick={() => toggleContent()}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            toggleContent();
          }
        }}
      >
        {pageIcon.kind === "img" ? (
          <img src={pageIcon.src} alt={currentPage} width={20} height={20} style={{ marginRight: "8px" }} />
        ) : (
          <i className={`${pageIcon.className} navi_sidebar_icon`} aria-hidden="true" style={{ marginRight: "8px" }} />
        )}
        <div className="d-flex align-items-center justify-content-between w-100">
          {currentPage}
          <span className="mobile_view__chevWrap" aria-hidden>
            <i className="ri-arrow-down-s-line mobile_view__chev" />
          </span>
        </div>
      </div>


      <div className={`dashboard${sidebarCollapsed ? " dashboard--sidebar-collapsed" : ""}`}>


        <div
          id="content"
          className={`${isActive ? "active flex-shrink-0 leftside_menu" : "flex-shrink-0 leftside_menu"} profile-sidebar-shell${sidebarCollapsed ? " profile-sidebar-shell--collapsed" : ""}${orderRail ? " profile-sidebar-shell--orders" : walletRail ? " profile-sidebar-shell--wallets" : " profile-sidebar-shell--dashboard"}`}
        >
          <button
            type="button"
            className="profile-sidebar-collapse-btn"
            onClick={() => setSidebarCollapsed((c) => !c)}
            aria-expanded={!sidebarCollapsed}
            aria-label={sidebarCollapsed ? "Expand navigation" : "Collapse navigation"}
          >
            <i className={sidebarCollapsed ? "ri-arrow-right-s-line" : "ri-arrow-left-s-line"} aria-hidden="true" />
          </button>

          {orderRail ? (
            <OrderSidebar toggleContent={toggleContent} />
          ) : walletRail ? (
            <WalletSidebar toggleContent={toggleContent} />
          ) : (
            <DashboardSidebar toggleContent={toggleContent} walletTypes={walletTypes} />
          )}
          {!orderRail && (
            <div className="logout_btn" onClick={logOut}>
              <Link to="#/">Logout<i className="ri-logout-circle-r-line"></i></Link>
            </div>
          )}
        </div>

        <Outlet />
      </div>
    </>
  )
}

export default ProfilePage